export const JOIN_JOURNEY_TYPE = {
  NEW: 'new',
  RESUMED: 'resumed'
};

export const RESUME_TYPE = {
  CLIENT: 'client',
  SERVER: 'server'
};

export const RESUME_STEPS = {
  ADDRESS_CHECK_SQ: 'Address Check SQ',
  NBN_CART: 'Nbn Cart',
  RESUMPTION_CALLOUT: 'Resumption Callout'
};
